/**
 * @generated SignedSource<<7a0d05d4d4657a6305ee4280f1e63010>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEstimateValueBadge_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowSimilarSoldItems_item">;
  readonly " $fragmentType": "PdpSharedEstimateValueBadge_item";
};
export type PdpSharedEstimateValueBadge_item$key = {
  readonly " $data"?: PdpSharedEstimateValueBadge_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimateValueBadge_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEstimateValueBadge_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "01ae72eff80497e5395fe414f7f303b6";

export default node;
